var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show_loader)?_c('div',{staticClass:"spinner-border text-success",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_c('div',[_vm._t("default",null,{"data":_vm.data})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }